import * as React from "react";
import {inject, observer} from "mobx-react";

import {AdBanner} from "@ok/web/components/base/AdBanner/AdBanner";
import {EmergedFooterBannerHook} from "OK/ads/banner/hook/EmergedFooterBannerHook";
import {promoBannerCloseEventType} from "OK/banners/promoBannerEvent";

import {RbAdBannerEmergedFooterStore} from "../../lib/RbAdBannerEmergedFooterStore";
import {RbAdBannerEmergedFooterController} from "../../lib/RbAdBannerEmergedFooterController";

import css from "./RbAdBannerEmergedFooter.styl";

export interface IRbAdBannerEmergedFooterProps {
    store?: RbAdBannerEmergedFooterStore;
    ctrl?: RbAdBannerEmergedFooterController;
}

@inject("store", "ctrl")
@observer
export class RbAdBannerEmergedFooter extends React.Component<IRbAdBannerEmergedFooterProps> {

    private hasPromoBannerCloseEventListener = false;

    private removePromoBannerCloseEventListener() {
        window.document.removeEventListener(promoBannerCloseEventType, this.onPromoBannerClose);
        this.hasPromoBannerCloseEventListener = false;
    }

    private onPromoBannerClose = () => {
        this.props.store?.setShow(true);
        this.removePromoBannerCloseEventListener();
    };

    componentDidMount() {
        const show = this.props.store?.initShow();
        if (show === false) {
            window.document.addEventListener(promoBannerCloseEventType, this.onPromoBannerClose);
            this.hasPromoBannerCloseEventListener = true;
        }
    }

    componentWillUnmount() {
        if (this.hasPromoBannerCloseEventListener) {
            this.removePromoBannerCloseEventListener();
        }
    }

    render() {
        const store = this.props.store;
        const settings = store?.settings;
        if (!store?.show || !settings || !settings.slot) {
            return;
        }

        return (
            <AdBanner
                bannerHookType={EmergedFooterBannerHook}
                bannerName={'EmergedFooter'}
                bannerParams={settings}
                className={css['box']}
            />
        );
    }
}
